<template>
  <div class="container-fixed">
    <h2>Post-invalidate</h2>

    <VForm :form="form5" optional-validation @submit="onSubmit5">
      <VInput name="input501" required hint="Invalid!" label="This requires min length of 10"> </VInput>
      <button id="form5_submit_button" type="submit" class="btn btn-brand">
        Submit
      </button>
    </VForm>
    isValid: {{ test2 }}

    <hr />

    <h2>disable-on-valid-submit example</h2>

    <p
      >With <code>disable-on-valid-submit</code> the scope variable <code>isDisabled</code> is set to true once the submit is called and all validations are
      succeeded.</p
    >

    <VForm v-slot="{ isDisabled }" :form="form3" disable-on-valid-submit @submit="onSubmit">
      <VInput name="input301" required hint="Invalid!" label="This requires min length of 10"> </VInput>

      <button type="submit" class="btn btn-brand" :disabled="isDisabled">Submit</button>
    </VForm>

    <hr />

    <h2>form utility functions example</h2>

    <p></p>

    <VForm :form="form2" optional-validation @submit="onSubmit">
      <VCheckbox label="required" required name="check201" hint="Invalid!">no default</VCheckbox>
      <VCheckbox label="required" required name="check202" hint="Invalid!" :model-value="true">default true</VCheckbox>
      <VCheckbox label="required" required name="check203" hint="Invalid!" :model-value="false">default false</VCheckbox>

      <VInput name="input204" required hint="Invalid!" label="length 10 or longer required"> </VInput>
      <VInput name="input205" required hint="Invalid!" label="length 10 or longer required" model-value="default205"> </VInput>
      <VInput name="input206" required hint="Invalid!" label="length 10 or longer required" model-value="OVERWRITTEN"> </VInput>

      <VMulticheckbox name="multicheck207" label="[true, false, true] required" hint="Invalid!" />
      <VSelect name="select208" label="" hint="Select hint" :model-value="2" />

      <button id="form2checkValidations" type="button" class="btn btn-default" @click="callCheckValidations">checkValidations</button>
      <button id="form2resetValidations" type="button" class="btn btn-default" @click="callResetValidations">resetValidations</button>
      <button id="form2resetValues" type="button" class="btn btn-default" @click="callResetValues">resetValues</button>
      <button id="form2focusFirst" type="button" class="btn btn-default" @click="callFocusFirst">focusFirst</button>
      <button id="form2focusFirstError" type="button" class="btn btn-default" @click="callFocusFirstError">focusFirstError</button>
      <br />
      <span data-test="form2_validity">IS VALID: {{ form2IsValid }}</span>
      <br />
      <span data-test="form2_values">{{ getFormValues(form2) }}</span>
    </VForm>

    <hr />

    <h2>Complex example of a form with lots of validations and mostly all combinations of fields:</h2>

    <VForm data-test="form1" :form="form" optional-validation @submit="onSubmit">
      <VSelect name="select1" label="Select label <b>with HTML</b> support" hint="Select hint" />

      <VSelect name="select2" label="SHOULD BE HIDDEN" hint="SHOULD BE HIDDEN" />

      <VCheckbox v-model="test0" label="Terms label <b>with html</b> support0. HIDDEN" required name="check0" hint="INVALID HINT <b>with HTML</b> support0">
        Slot-Content <b>with HTML</b> support0
      </VCheckbox>

      <p>Optionally it is possible to add a <code>v-model</code> to any field, to have direct access to the value.</p>

      <VCheckbox
        v-model="test1"
        label="Terms label <b>with html</b> support1. Required. With Model."
        required
        name="check1"
        hint="INVALID HINT <b>with HTML</b> support1"
      >
        Slot-Content <b>with HTML</b> support1
      </VCheckbox>

      <p data-test="value1">VALUE: {{ test1 }}</p>

      <VCheckbox label="Terms label <b>with html</b> support2. Required. WITHOUT Model." required name="check2" hint="INVALID HINT <b>with HTML</b> support2">
        Slot-Content <b>with HTML</b> support2
      </VCheckbox>

      <VCheckbox
        label="Terms label <b>with html</b> support3. NOT required. WITHOUT Model."
        :required="false"
        name="check3"
        hint="INVALID HINT <b>with HTML</b> support3"
      >
        Slot-Content <b>with HTML</b> support3
      </VCheckbox>

      <VCheckbox
        v-model="test4"
        label="Terms label <b>with html</b> support4. NOT required. With Model."
        :required="false"
        name="check4"
        hint="INVALID HINT <b>with HTML</b> support4"
      >
        Slot-Content <b>with HTML</b> support4
      </VCheckbox>

      <VCheckbox
        v-model="test5"
        label="Terms label <b>with html</b> support5. Required. With Model. DEFAULT = TRUE"
        required
        name="check5"
        hint="INVALID HINT <b>with HTML</b> support5"
      >
        Slot-Content <b>with HTML</b> support5
      </VCheckbox>

      <VCheckbox label="-" required name="check6" hint="-">
        IS NOT VISIBLE AT ALL
      </VCheckbox>

      <VCheckbox v-model="test6" label="Terms label <b>with html</b> support6. WITHOUT FORM + NAME" required hint="INVALID HINT <b>with HTML</b> support6">
        Slot-Content <b>with HTML</b> support0
      </VCheckbox>

      <p data-test="value6">VALUE: {{ test6 }}</p>

      <VCheckbox required name="check7" hint="INVALID HINT <b>with HTML</b> support7"> Slot-Content <b>with HTML</b> support7 (no label) </VCheckbox>

      <VMulticheckbox name="check8" label="Multicheckbox <b>HTML</b> label8" hint="INVALID HINT <b>with HTML</b> multicheckbox" />

      <VMulticheckbox name="check9" label="Multicheckbox <b>HTML</b> label9" hint="INVALID HINT <b>with HTML</b> multicheckbox" />

      <VMulticheckbox name="check10" label="Multicheckbox <b>HTML</b> via String-Array" hint="INVALID HINT <b>with HTML</b> multicheckbox" />

      <VMulticheckbox name="check11" required label="Multicheckbox <b>HTML</b> required via HTML" hint="INVALID HINT <b>with HTML</b> multicheckbox" />

      <VMulticheckbox name="check12" label="Multicheckbox <b>HTML</b> HIDDEN" hint="INVALID HINT <b>with HTML</b> multicheckbox" />

      <VInput
        v-model="input1"
        name="input1"
        placeholder="max.mustermann@t-online.de"
        label="Input <b>HTML</b> #1: Required + e-mail validation"
        required
        label-as-required
        hint="Hint <b>with HTML</b> support"
        autocomplete="email"
      >
      </VInput>

      <p data-test="value_input1">VALUE: {{ input1 }}</p>

      <VInput
        v-model="input2"
        name="input2"
        placeholder="max.mustermann@t-online.de"
        label="Input <b>HTML</b> #2: NOT Required but e-mail validation"
        hint="Hint <b>with HTML</b> support"
        autocomplete="email"
      >
      </VInput>

      <VInput
        v-model="input3"
        name="input3"
        label="Input <b>HTML</b> #3: NOT Required but minlength(3) validation + isValidDescriptionValue"
        hint="Hint <b>with HTML</b> support"
      >
      </VInput>

      <VInput v-model="input4" name="input4" label="Input <b>HTML</b> #4: DISABLED" hint="Hint <b>with HTML</b> support"> </VInput>

      <VInput v-model="input5" name="input5" label="Input <b>HTML</b> #5: combined validation: e-mail and minlength(15)" hint="Hint <b>with HTML</b> support" required label-as-required autocomplete="email">
      </VInput>

      <VInput v-model="input6" name="input6" label="Input <b>HTML</b> #6: WITHOUT form!" hint="Hint <b>with HTML</b> support"> </VInput>

      <p data-test="value_input6">VALUE: {{ input6 }}</p>

      <VInput
        v-model="input7"
        name="input7"
        label="Input <b>HTML</b> #7: combined validation: e-mail and minlength(15) with individual error"
        required
        label-as-required
        hint="Hint <b>with HTML</b> support - STANDARD HINT"
        autocomplete="email"
      >
      </VInput>

      <VInput name="input8" label="Input <b>HTML</b> #8: no model + minlength(3)" hint="Hint <b>with HTML</b> support - STANDARD HINT"> </VInput>

      <VInput
        name="input9"
        label="Label"
        :hint="'Sie haben eine nicht unterstütze oder ungültige Rufnummer definiert. Bitte geben Sie eine gültige Festnetznummer ein'"
        placeholder="Placeholder"
      />

      <button type="submit" class="btn btn-brand">
        Submit
      </button>

      <span data-test="form1_valid">IS VALID: {{ isValid }}</span>
      <hr />
      <span data-test="form1_values">{{ getFormValues(form) }}</span>
    </VForm>
    <hr />
    <h2>Checking the placeholder for select boxes</h2>
    <VForm data-test="form6" :form="form6">
      <VSelect name="select601" label="Select without placeholder" />
      <VSelect name="select602" label="required select with placeholder" placeholder="required select placeholder" required />
      <VSelect name="select603" label="optional select with placeholder" placeholder="optional select placeholder" />
      <VSelect name="select604" label="preselect with valid value (via model)" :model-value="2" placeholder="required select placeholder" />
      <VSelect name="select605" label="preselect with valid value (via initFields)" placeholder="required select placeholder" />
      <VSelect v-model="select606InvalidDefault" name="select606" label="preselect with invalid value" placeholder="optional select placeholder" />
      model value: {{ select606InvalidDefault }} {{ select606InvalidDefault === '' ? '(is empty string)' : '' }}
      <hr />
      <span data-test="form6_values">{{ getFormValues(form6) }}</span>
    </VForm>
    <hr />

    <h2>Accessibility on Checkbox components</h2>

    <VForm :form="form7" optional-validation>
      <VCheckbox label="Test für Pflichteingabe bei Checkboxen" required name="check701" hint="Die Checkbox muss ausgewählt werden!">no default</VCheckbox>
      <button id="form7_submit_button" type="submit" class="btn btn-brand">
        Submit
      </button>
    </VForm>

    <hr />

    <h2>Accessibility on Multi-Checkbox components</h2>

    <VForm :form="form8" optional-validation>
      <VMulticheckbox name="multicheck801" label="Test für Pflichtfeld bei Multi-Checkboxen" required hint="Es müssen alle Optionen ausgewählt werden." />
      <button id="form8_submit_button" type="submit" class="btn btn-brand">
        Submit
      </button>
    </VForm>

    <hr />

    <h2>Accessibility on Select components</h2>

    <VForm :form="form9" optional-validation>
      <VSelect name="select901" label="Wähle eine Option" hint="hint" required />
      <button id="form9_submit_button" type="submit" class="btn btn-brand">
        Submit
      </button>
    </VForm>

    <hr />
  </div>
</template>

<script>
import VForm from '@/components/Form/Form';
import VInput from '@/components/Form/Input';
import VCheckbox from '@/components/Form/Checkbox';
import VMulticheckbox from '@/components/Form/MultiCheckbox';
import VSelect from '@/components/Form/Select';
import {
  checkValidations,
  focusFirst,
  focusFirstError,
  initFields,
  isValidEmail,
  isValidEmailOrEmpty,
  hasMinLength,
  isEqualTo,
  match,
  isValidDescriptionValue,
  getFormValues,
  isValidFixedLineNumber,
  checkSupportedFixedLineNumbers,
  formattedFixedLineNumber,
  resetValidations,
  resetValues,
} from '@/utils/form';

export default {
  name: 'TestForm',

  components: {
    VForm,
    VInput,
    VCheckbox,
    VMulticheckbox,
    VSelect,
  },

  data() {
    const form6 = initFields(
      {
        name: 'select601',
        items: [
          { id: 1, label: 'default' },
          { id: 2, label: 'alternative' },
        ],
      },
      {
        name: 'select602',
        items: [
          { id: 1, label: 'foo' },
          { id: 2, label: 'bar' },
        ],
      },
      {
        name: 'select603',
        items: [
          { id: 1, label: 'foo' },
          { id: 2, label: 'bar' },
        ],
      },
      {
        name: 'select604',
        items: [
          { id: 1, label: 'alternative' },
          { id: 2, label: 'default' },
        ],
      },
      {
        name: 'select605',
        items: [
          { id: 1, label: 'alternative' },
          { id: 2, label: 'default' },
        ],
        value: 2,
      },
      {
        name: 'select606',
        items: [
          { id: 1, label: 'foo' },
          { id: 2, label: 'bar' },
        ],
      }
    );
    const form7 = initFields({ name: 'check701' });
    const form8 = initFields({
      name: 'multicheck801',
      items: [
        { label: 'erstes Auswahloption', hint: 'Die erste Option muss ausgewählt werden!' },
        { label: 'zweite Auswahloption', hint: 'Die zweite Option muss ausgewählt werden!' },
      ],
    });
    const form9 = initFields({
      name: 'select901',
      items: [
        { id: 1, label: 'erste Auswahloption' },
        { id: 2, label: 'zweite Auswahloption' },
      ],
      validators: [
        { handler: id => id === '1', hint: 'Es ist nur die erste Auswahloption erlaubt.' }, // first option is not valid
      ],
    });
    const form5 = initFields({ name: 'input501', validators: [hasMinLength(10)] });
    const form4 = initFields({ name: 'input401', validators: [hasMinLength(10)] }, { name: 'input402', validators: [hasMinLength(10)] });
    const form3 = initFields({ name: 'input301', validators: [hasMinLength(10)] });
    const form2 = initFields(
      { name: 'check201' },
      { name: 'check202' },
      { name: 'check203' },
      { name: 'input204', validators: [hasMinLength(10)] },
      { name: 'input205', validators: [hasMinLength(10)] },
      { name: 'input206', validators: [hasMinLength(10)], value: 'default206' },
      {
        name: 'multicheck207',
        items: [
          { label: 'default false', required: true, value: false },
          { label: 'default true', required: false, value: true },
          { label: 'default false', required: true, value: false },
        ],
      },
      {
        name: 'select208',
        items: [
          { id: 1, label: 'alternative' },
          { id: 2, label: 'default' },
        ],
      }
    );

    const form = initFields(
      {
        name: 'select1',
        items: [
          { id: 1, label: 'text 1' },
          { id: 2, label: 'text 2' },
        ],
      },
      { name: 'select2', items: [], isHidden: true },
      { name: 'check0', isHidden: true },
      'check1',
      'check2',
      'check3',
      'check4',
      'check5',
      'check6',
      'check7',
      {
        name: 'check8',
        items: [
          { label: 'First required', required: true },
          { label: 'Second NOT required' },
          { label: 'Third required OTHER HINT', required: true, hint: 'This is a special hint' },
        ],
      },
      {
        name: 'check9',
        required: true,
        items: [{ label: 'First required' }, { label: 'Second NOT required', required: false }, { label: 'Third required' }],
      },
      {
        name: 'check10',
        required: true,
        items: ['First required', 'Second required', 'Third required'],
      },
      {
        name: 'check11',
        items: ['First required', 'Second required', 'Third required'],
      },
      {
        name: 'check12',
        isHidden: true,
        required: true,
        items: ['First required', 'Second required', 'Third required'],
      },
      { name: 'input1', validators: isValidEmail },
      { name: 'input2', validators: isValidEmailOrEmpty },
      { name: 'input3', validators: [hasMinLength(3), isValidDescriptionValue] },
      { name: 'input4', isHidden: true },
      { name: 'input5', validators: [isValidEmail, hasMinLength(15)] },
      {
        name: 'input7',
        validators: [
          { handler: isValidEmail, hint: 'Die eingegebene E-Mail Adresse ist ungültig' },
          { handler: hasMinLength(15), hint: 'Die Eingabe muss mindestens 15 Zeichen lang sein' },
          { handler: isEqualTo('input1'), hint: 'Die E-Mail muss identisch sein mit "input1"' },
          { handler: match(/^a.*$/), hint: "Die E-Mail muss mit 'a' anfangen" },
        ],
      },
      { name: 'input8', validators: [hasMinLength(3)] },
      {
        name: 'input9',
        validators: [isValidFixedLineNumber, checkSupportedFixedLineNumbers],
        filters: [formattedFixedLineNumber],
      }
    );

    // nachträglich
    form.check6.isHidden = true;

    return {
      getFormValues,
      test0: false,
      test1: false,
      test4: false,
      test5: true,
      test6: false,
      input1: '',
      input2: '',
      input3: '',
      input4: '',
      input5: 'Default value',
      input6: '',
      input7: '',
      form,
      form2,
      form3,
      form4,
      form5,
      form6,
      form7,
      form8,
      form9,
      isValid: 'unknown',
      test2: null,
      form2IsValid: 'unknown',
      select606InvalidDefault: 5,
    };
  },

  methods: {
    onSubmit({ isValid }) {
      this.isValid = isValid;
    },
    onSubmit5({ form, isValid }) {
      if (isValid) {
        form.input501.setInvalid('this message was added after submitting');
        focusFirst(form);
      }
    },

    callCheckValidations() {
      this.form2IsValid = String(checkValidations(this.form2));
    },
    callResetValidations() {
      resetValidations(this.form2);
      this.form2IsValid = 'unknown';
    },
    callResetValues() {
      resetValues(this.form2);
    },
    callGetFormValues() {
      this.form2Values = getFormValues(this.form2);
    },
    callFocusFirst() {
      focusFirst(this.form2);
    },
    callFocusFirstError() {
      focusFirstError(this.form2);
    },
  },
};
</script>
